import { Card } from "@/components/ui/card";
import { Users } from "lucide-react";
import type { CountBucket, ServiceCounts } from "@/lib/serviceCounts";

const plural = (n: number, word: string) => `${n} ${word}${n > 1 ? "s" : ""}`;

function Line({ label, bucket, strong }: { label: string; bucket: CountBucket; strong?: boolean }) {
  return (
    <div className="flex items-baseline justify-between gap-3 py-1">
      <span className={strong ? "text-sm font-semibold text-foreground" : "text-sm text-muted-foreground"}>
        {label}
      </span>
      <span className={`text-sm tabular-nums text-right ${strong ? "font-bold text-foreground" : "text-foreground"}`}>
        {plural(bucket.reservations, "résa")} · {plural(bucket.people, "couvert")}
        {strong && bucket.children > 0 && (
          <span className="text-muted-foreground font-normal"> (dont {plural(bucket.children, "enfant")})</span>
        )}
      </span>
    </div>
  );
}

interface Props {
  dayLabel: string;
  counts: ServiceCounts;
}

export function DayServiceSummary({ dayLabel, counts }: Props) {
  return (
    <Card className="p-3 mb-2">
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 shrink-0 bg-primary/10 rounded-lg flex items-center justify-center">
          <Users className="w-4 h-4 text-primary" />
        </div>
        <div className="flex-1 min-w-0 divide-y divide-border">
          <Line label={dayLabel} bucket={counts.day} strong />
          {counts.services.length > 1 &&
            counts.services.map((s) => (
              <Line key={`${s.start}-${s.end}`} label={`Service ${s.start}–${s.end}`} bucket={s} />
            ))}
          {counts.outOfService.reservations > 0 && (
            <Line label="Hors service" bucket={counts.outOfService} />
          )}
        </div>
      </div>
    </Card>
  );
}
